var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"speciality"},[_c('span',{staticClass:"crm-title"},[_vm._v(" "+_vm._s(_vm.speciality.title)+" ")]),(_vm.edit)?_c('icon-clear',{staticClass:"crm-icon-cross",on:{"click":_vm.onClickCross}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }